export default __webpack_public_path__ + "static/media/mead_pre_bottle.0560ce0d.jpg";